module.exports = __webpack_public_path__ + "img/schets-12.03a73532.jpg";